// Inline-SVG action icons tuned per platform (stroke width, fill style) so the rows look
// authentic rather than generic Material icons.

import { SvgIcon } from '@mui/material';

const stroke = { fill: 'none', stroke: 'currentColor' };
const filled = { fill: 'currentColor' };

export const FbLikeIcon = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            {...stroke}
            strokeWidth="1.6"
            strokeLinejoin="round"
            d="M7 10v9h10.3a1.7 1.7 0 0 0 1.7-1.3l1.7-6.5c.2-1-.5-1.9-1.6-1.9h-4.5l.7-3.5A1.5 1.5 0 0 0 13.8 4l-.6.2L9 9v1H7zM4 10h3v9H4z"
        />
    </SvgIcon>
);

export const FbCommentIcon = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            {...stroke}
            strokeWidth="1.6"
            strokeLinejoin="round"
            d="M12 3c5 0 9 3.6 9 8 0 4.4-4 8-9 8-1 0-2-.2-2.9-.5L4 20l1.5-3.5C4.6 15.2 4 13.7 4 12c0-5 4-9 8-9z"
        />
    </SvgIcon>
);

export const FbShareIcon = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            {...stroke}
            strokeWidth="1.6"
            strokeLinejoin="round"
            strokeLinecap="round"
            d="M4 16c0-5 4-7 9-7V5l8 7-8 7v-4c-4 0-7 .7-9 1z"
        />
    </SvgIcon>
);

export const IgHeartIcon = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            {...stroke}
            strokeWidth="1.7"
            strokeLinejoin="round"
            strokeLinecap="round"
            d="M12 20.5s-7.5-4.4-7.5-10.2A4.3 4.3 0 0 1 12 7.6a4.3 4.3 0 0 1 7.5 2.7c0 5.8-7.5 10.2-7.5 10.2z"
        />
    </SvgIcon>
);

export const IgCommentIcon = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            {...stroke}
            strokeWidth="1.7"
            strokeLinejoin="round"
            strokeLinecap="round"
            d="M20 11.5A8 8 0 0 1 7.5 18L3.5 19l1.2-3.5A8 8 0 1 1 20 11.5z"
        />
    </SvgIcon>
);

export const IgDmIcon = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            {...stroke}
            strokeWidth="1.7"
            strokeLinejoin="round"
            strokeLinecap="round"
            d="M22 3 11 14M22 3l-7 18-4-7-7-4z"
        />
    </SvgIcon>
);

export const IgBookmarkIcon = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path {...stroke} strokeWidth="1.7" strokeLinejoin="round" strokeLinecap="round" d="M6 3h12v18l-6-4-6 4z" />
    </SvgIcon>
);

export const TtHeartIcon = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path {...filled} d="M12 21s-8-4.6-8-11a4.7 4.7 0 0 1 8-3.4A4.7 4.7 0 0 1 20 10c0 6.4-8 11-8 11z" />
    </SvgIcon>
);

export const TtCommentIcon = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path {...filled} d="M12 3a9 9 0 0 0-7.6 13.9L3 21l4.3-1.3A9 9 0 1 0 12 3z" />
    </SvgIcon>
);

export const TtBookmarkIcon = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path {...filled} d="M6 3h12v18l-6-4.2L6 21z" />
    </SvgIcon>
);

export const TtShareIcon = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path {...filled} d="M4 16.5c0-5.5 5-7.5 10-7.5V4.5l8 7.5-8 7.5v-4.5c-4.5 0-8 .8-10 1.5z" />
    </SvgIcon>
);

export const XReplyIcon = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path {...stroke} strokeWidth="1.7" strokeLinejoin="round" strokeLinecap="round" d="M4 5h16v11H9l-5 4z" />
    </SvgIcon>
);

export const XRetweetIcon = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            {...stroke}
            strokeWidth="1.7"
            strokeLinejoin="round"
            strokeLinecap="round"
            d="M7 7h9l-2.5-2.5M7 7v8M17 17H8l2.5 2.5M17 17V9"
        />
    </SvgIcon>
);

export const XLikeIcon = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            {...stroke}
            strokeWidth="1.7"
            strokeLinejoin="round"
            strokeLinecap="round"
            d="M12 20.5s-7.5-4.4-7.5-10.2A4.3 4.3 0 0 1 12 7.6a4.3 4.3 0 0 1 7.5 2.7c0 5.8-7.5 10.2-7.5 10.2z"
        />
    </SvgIcon>
);

export const XViewsIcon = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            {...stroke}
            strokeWidth="1.7"
            strokeLinejoin="round"
            strokeLinecap="round"
            d="M5 20V10M12 20V4M19 20v-7"
        />
    </SvgIcon>
);

export const XShareIcon = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            {...stroke}
            strokeWidth="1.7"
            strokeLinejoin="round"
            strokeLinecap="round"
            d="M12 3v12M12 3 8 7M12 3l4 4M5 12v8h14v-8"
        />
    </SvgIcon>
);
